export const APP_ERROR_SESSION_KEY = 'mpa_app_error';

export type AppErrorSessionPayload = {
  message: string;
  reason?: string;
  lockApp: boolean;
};

export const setAppErrorRedirectPayload = ({ message, reason, lockApp }: AppErrorSessionPayload): void => {
  sessionStorage.setItem(
    APP_ERROR_SESSION_KEY,
    JSON.stringify({
      message,
      reason,
      lockApp,
    })
  );
};

export const readAppErrorSessionPayload = (): AppErrorSessionPayload | null => {
  const raw = sessionStorage.getItem(APP_ERROR_SESSION_KEY);
  if (!raw?.trim()) {
    return null;
  }

  try {
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== 'object') {
      return null;
    }

    const record = parsed as Record<string, unknown>;
    const message = typeof record.message === 'string' ? record.message : '';
    const reason = typeof record.reason === 'string' ? record.reason : undefined;
    const lockApp = record.lockApp === true;

    return { message, reason, lockApp };
  } catch (error) {
    console.error('Error reading app error session payload:', error);
    return null;
  }
};

export const clearAppErrorSessionStorage = (): void => {
  sessionStorage.removeItem(APP_ERROR_SESSION_KEY);
};

export const isAppAccessLocked = (): boolean => {
  const payload = readAppErrorSessionPayload();
  return payload?.lockApp === true;
};
